export default "__VITE_ASSET__DcsbjhzY__"